import { Dispatch, SetStateAction, useEffect, useState } from "react";
import cn from "classnames";
import { TabControl } from "./TabControl";
import { TabControlLabel } from "./TabControlLabel";
import { TabsBody } from "./TabsBody";
import { TabsControlGroup } from "./TabsControlGroup";
import { TabsPanel } from "./TabsPanel";
import { TabsRow } from "./TabsRow";
import styles from "./Tabs.module.scss";

import { TabsContext } from "./Tabs.context";

interface TabsBaseProps {
  className?: string;
  initialTabId?: string;
  onChangeActiveTab?: Dispatch<SetStateAction<string>>;
}

const TabsBase: RFC<TabsBaseProps> = ({ className, children, onChangeActiveTab, initialTabId = "" }) => {
  const [activeTabId, setActiveTabId] = useState<string>(initialTabId);

  useEffect(() => {
    if (initialTabId) {
      onChangeActiveTab?.(activeTabId);
    }
  }, [initialTabId]);

  return (
    <TabsContext.Provider
      value={{
        activeTabId,
        setActiveTabId: (tabId: string) => {
          setActiveTabId(tabId);
          onChangeActiveTab?.(tabId);
        },
      }}
    >
      <div className={cn(styles.tabs, className)}>{children}</div>
    </TabsContext.Provider>
  );
};

type CompoundTabs = typeof TabsBase & {
  Row: typeof TabsRow;
  Group: typeof TabsControlGroup;
  Control: typeof TabControl;
  ControlLabel: typeof TabControlLabel;
  Body: typeof TabsBody;
  Panel: typeof TabsPanel;
};

export const Tabs = TabsBase as CompoundTabs;
Tabs.displayName = "Tabs";

Tabs.Row = TabsRow;
Tabs.Group = TabsControlGroup;
Tabs.Control = TabControl;
Tabs.ControlLabel = TabControlLabel;
Tabs.Body = TabsBody;
Tabs.Panel = TabsPanel;
